angular.module('myApp.menus', ['ngRoute']).config(['$routeProvider', '$locationProvider',
    function ($routeProvider, $locationProvider) {

        $routeProvider.when('/fatafat/restaurant/:id/:namecity', {
            redirectTo:function (routeParams, path, search) {

                return '/fatafat/'+ routeParams.namecity.substr(routeParams.namecity.lastIndexOf("-")+1)+'/restaurants/'+routeParams.id+'/' + routeParams.namecity;

            }
        })

        $routeProvider.when('/fatafat', {
            templateUrl: 'components/menus/menus.html',
            controller: 'menus2Ctrl'
        })
        $routeProvider.when('/fatafat/:city_name', {
            templateUrl: 'components/menus/categories.html',
            controller: 'categoriesCtrl'
        })
        $routeProvider.when('/fatafat/:city_name/anything', {
            templateUrl: 'components/menus/anything.html',
            controller: 'anythingCtrl'
        })

        $routeProvider.when('/fatafat/:city_name/anything/checkout', {
            templateUrl: 'components/menus/anythingCheckout.html',
            controller: 'anythingCheckoutCtrl'
        })
        $routeProvider.when('/fatafat/:city_name/:category_name', {
            templateUrl: 'components/menus/restaurants.html',
            controller: 'menusCtrl'
        })
        $routeProvider.when('/fatafat/:city_name/:category_name/:dish', {
            templateUrl: 'components/menus/dish.html',
            controller: 'dishCtrl'
        })



    }
]).filter('dashFilter', function () {
    return function (input) {
        return input.replace(/[^a-zA-Z0-9 ]/g, "").replace(/ /g, '-').replace('--', '-');
    }
}).controller('menus2Ctrl', ['$scope', '$rootScope', '$window', '$timeout', '$location', 'API',  '$mdDialog',
    function ($scope, $rootScope, $window, $timeout, $location, API, $mdDialog) {


        $scope.city;


        $window.scrollTo(0, 0);


        function showAlert() {
            alert = $mdDialog.alert({

                textContent: $scope.error,
                ok: 'Close'
            });

            $mdDialog
                .show(alert)
                .finally(function () {
                    alert = undefined;
                });
        }

        $scope.buttonLoader = false;



        //var input = document.getElementById('LocSearch');
        var options = {
            componentRestrictions: {
                country: 'ind'
            }
        };

        //var autocomplete = new google.maps.places.Autocomplete(input, options);
        //google.maps.event.addListener(autocomplete, 'place_changed', function () {
        //    $scope.buttonLoader = true;
        //    $scope.getCategories()
        //})

        getFatafatCities()

        function getFatafatCities() {
            $rootScope.loading_custom = true;

            API.get(menu_base_url + 'website/get_cities').then(function (result) {
                $rootScope.loading_custom = true;
                console.log(result)
                if (result.data.flag == 143) {
                  console.log(result);
                    $scope.cities = result.data.cities;
                    $scope.city_selected = "";
                    $rootScope.loading_custom = false;
                }
                else {
                    $scope.error = result.data.error
                    $rootScope.loading_custom = false;
                }
            })

        }

        $scope.selectCity = function (city){
            $scope.city_selected = city;
                console.log(JSON.parse(city));
            city = JSON.parse(city);
            $location.path("fatafat/" + city.city_name.toLowerCase().replace(' ', '-'));
            $rootScope.link = "/fatafat/" + city.city_name.toLowerCase().replace(' ', '-');
            $scope.buttonLoader = false;
                localStorage.setItem('lat', city.latitude);
                localStorage.setItem('long', city.longitude);
                localStorage.setItem('city_id',city.city_id);
                $rootScope.userLocation = city.city_name;
                localStorage.setItem('userLocation',city.city_name);

        }


        //$scope.getCategories = function () {
        //
        //
        //    var location = autocomplete.getPlace();
        //
        //
        //    if (location) {
        //        localStorage.setItem('lat', parseFloat(location.geometry.location.lat()));
        //        localStorage.setItem('long', parseFloat(location.geometry.location.lng()));
        //
        //
        //        var latlong = {
        //            lat: localStorage.getItem('lat'),
        //            long: localStorage.getItem('long')
        //        }
        //        localStorage.setItem("userLocation", JSON.stringify(latlong));
        //        var address = $('#LocSearch').val();
        //        localStorage.setItem("userLocation", address);
        //        $rootScope.userLocation = localStorage.getItem("userLocation");
        //
        //        geocoder = new google.maps.Geocoder();
        //        if (geocoder) {
        //            geocoder.geocode({
        //                'address': $rootScope.userLocation
        //            }, function (results, status) {
        //                if (status == google.maps.GeocoderStatus.OK) {
        //                    if (results[0]) {
        //                        //formatted address
        //                        var counter = 0;
        //                        //find country name
        //                        for (var i = 0; i < results[0].address_components.length; i++) {
        //
        //                            for (var b = 0; b < results[0].address_components[i].types.length; b++) {
        //
        //                                //there are different types that might hold a city admin_area_lvl_1 usually does in come cases looking for sublocality type will be more appropriate
        //                                if (results[0].address_components[i].types[b] == "locality") {
        //                                    //this is the object you are looking for
        //                                    $scope.city = results[0].address_components[i];
        //                                    if ($scope.city.long_name.toLowerCase() == "bengaluru") {
        //                                        $scope.city.long_name = "banglore";
        //                                    }
        //                                    else if ($scope.city.long_name.toLowerCase() == "gurugram") {
        //                                        $scope.city.long_name = "gurgaon";
        //                                    }
        //                                    else if($scope.city.long_name.toLowerCase() == "panchkula" || $scope.city.long_name.toLowerCase() == "kharar" || $scope.city.long_name.toLowerCase() == "zirakpur" || $scope.city.long_name.toLowerCase() == "mohali"|| $scope.city.long_name.toLowerCase() == "sahibzada ajit singh nagar" || $scope.city.long_name.toLowerCase() == "landran" ) {
        //                                        $scope.city.long_name = "chandigarh";
        //                                    }
        //                                    $scope.$apply(function () {
        //
        //                                        $location.path("fatafat/" + $scope.city.long_name.toLowerCase().replace(' ', '-'));
        //                                        $rootScope.link = "/fatafat/" + $scope.city.long_name.toLowerCase().replace(' ', '-');
        //                                        $scope.buttonLoader = false;
        //                                    });
        //                                    counter++;
        //
        //                                    break;
        //                                }
        //
        //                            }
        //                        }
        //
        //
        //                    }
        //                    if (counter == 0) {
        //                        $scope.error = "Enter your locality"
        //                        showAlert();
        //                        $scope.buttonLoader = false;
        //                    }
        //
        //                }
        //            });
        //        }
        //
        //
        //    }
        //    else {
        //        $scope.error = "Enter your loaction"
        //        showAlert();
        //    }
        //
        //
        //}



    }]).controller('menusCtrl', ['$scope', '$rootScope', '$window', '$timeout', '$location', 'API', '$routeParams', '$document', function ($scope
    , $rootScope, $window, $timeout, $location, API, $routeParams, $document) {

    $scope.mainBaseUrl = new $window.URL($location.absUrl()).origin;
    var selcityname = $routeParams.city_name;
    $scope.mainSelectedCity = $routeParams.city_name;
    $scope.category = $routeParams.category_name.charAt(0).toUpperCase() + $routeParams.category_name.substr(1).toLowerCase();
    var Category = $routeParams.category_name.replace(/-/g, ' ');
    $scope.mainSelectedCity = $scope.mainSelectedCity.charAt(0).toUpperCase() + $scope.mainSelectedCity.substr(1).toLowerCase();

    $scope.dishes = ["biryani","milk-shake","north-indian","south-indian","parantha","aloo-parantha","dosa","masala-dosa","chinese","italian","fast-food","healthy-food","mughlai","rajasthani","seafood","sindhi","tibetan","mexican","tandoori","american","continental","oriental","arabic","gujarati","kashmiri","lebanese"]


    switch ($routeParams.category_name) {
        case 'restaurants':
            $scope.title = 'Order Online from ' + $scope.category + ' in ' + $scope.mainSelectedCity + ' - Jugnoo Fatafat';
            $scope.description = 'Get food from hundreds of ' + $scope.category + ' online in ' + $scope.mainSelectedCity + ' on Jugnoo Fatafat. Place your order online through our app, and leave the rest to us. We get the good stuff delivered to your door, in minutes. '
            $scope.heading = $scope.category + ' in ' + $scope.mainSelectedCity
            break;
        case 'chemists':
        case 'bakery':
        case 'book-stores':
        case 'sports-shops':
        case 'hardware-stores':
            $scope.title = 'Order Online from ' + $scope.category + ' in ' + $scope.mainSelectedCity + ' - Jugnoo Fatafat';
            $scope.description = 'Explore hundreds of ' + $scope.category + ' online in ' + $scope.mainSelectedCity + ' on Jugnoo Fatafat. Place your order online through our app, and leave the rest to us. We get the good stuff delivered to your door, in minutes. '
            $scope.heading = $scope.category + ' in ' + $scope.mainSelectedCity
            break;
        case 'groceries':
        case 'gifts':
        case 'electronics':
        case 'pet-supplies':
            $scope.title = 'Order ' + $scope.category + ' online  in ' + $scope.mainSelectedCity + ' - Jugnoo Fatafat';
            $scope.description = 'Explore hundreds of ' + $scope.category + ' online in ' + $scope.mainSelectedCity + ' on Jugnoo Fatafat. Place your order online through our app, and leave the rest to us. We get the good stuff delivered to your door, in minutes. '
            $scope.heading = $scope.category + ' in ' + $scope.mainSelectedCity
            break;
        default:
            $scope.title = 'Get Anything Delivered- Food, Grocery, Medicine & More - Jugnoo Fatafat';
            $scope.description = 'Jugnoo Fatafat offers on-demand delivery of everything you need, whenever you need it. Food delivery, grocery delivery, medicine delivery, and more—we’ll bring the best of your city to you, in minutes. We get the good stuff delivered to your door, in minutes.'
            $scope.heading = 'Stores in ' + $scope.mainSelectedCity
            break;
    }


    $scope.cityId = localStorage.getItem('city_id');
    //function getFatafatCities() {
    //         $rootScope.loading_custom = true;
    //
    //        API.get(menu_base_url + 'website/get_cities').then(function (result) {
    //            $rootScope.loading_custom = true;
    //            console.log(result)
    //            if (result.data.flag == 143) {
    //                var fatafatCities = result.data.cities;
    //                var count = 1;
    //                for (i = 0; i < fatafatCities.length; i++) {
    //                    if ($routeParams.city_name.toLowerCase().replace(/-/g, ' ') == fatafatCities[i].city_name.toLowerCase()) {
    //                        if (!localStorage.getItem('lat')) {
    //                            localStorage.setItem('lat', fatafatCities[i].latitude);
    //                            localStorage.setItem('long', fatafatCities[i].longitude);
    //                            $scope.cityId = fatafatCities[i].city_id;
    //                        }
    //                        fetchCategories();
    //
    //                        break;
    //                    }
    //                    if(count == fatafatCities.length){
    //                        $location.path('/404');
    //                        $rootScope.loading_custom = false;
    //
    //                    }
    //                    count++;
    //                }
    //            }
    //            else {
    //                $scope.error = result.data.error
    //                $rootScope.loading_custom = false;
    //            }
    //        })
    //
    //}
    var pageNo = $location.search().page;
    $scope.getRestaurantList = function () {
        API.post(menu_base_url + "nearby_restaurants_v2", {
            access_token: guestToken,
            device_type: "0",
            app_version: "365",
            client_id: "DC311uhPSZV6tKjT",
            login_type: 0,
            longitude: localStorage.getItem('long'),
            integrated: "1",
            latitude: localStorage.getItem('lat'),
            page_no:pageNo? pageNo - 1 : 0,
            filters: JSON.stringify(filters),
            merchant_category_id: $scope.selectedCategory

        }).then(function (result) {

            $window.scrollTo(0, 0);
            $scope.restData = result.data.vendors;
            $rootScope.loading_custom = false;
            $scope.totalResults = result.data.total_count;
            $scope.totalPages = Math.ceil($scope.totalResults / 20)
            $scope.pageArray = new Array($scope.totalPages);

            if (pageNo) {
                $scope.currentPage = parseInt(pageNo);
                $scope.startCount = 0;
                $scope.endCount = 5;

                if (pageNo > 5) {
                    if (pageNo % 5 == 0) {
                        $scope.startCount = pageNo - 5;
                        $scope.endCount = parseInt(pageNo);

                    }
                    else {
                        $scope.startCount = pageNo - pageNo % 5;
                        $scope.endCount = $scope.startCount + 5;

                    }
                }
                if(pageNo >  $scope.totalPages)
                {
                    $location.path('/not-available');
                }
            }
            else {
                    $scope.startCount = 0;
                    $scope.endCount = 5;
                    $scope.currentPage = 1;
            }

            $rootScope.loading_custom = false;

        })
    }

    function fetchCategories() {
        API.post(menu_base_url + "nearby_restaurants_v2", {
            access_token: guestToken,
            app_version: "364",
            device_type: "0",
            integrated: "1",
            client_id: "DC311uhPSZV6tKjT",
            latitude: localStorage.getItem('lat'),
            longitude: localStorage.getItem('long'),
            page_no: "0"

        }).then(function (result) {

            $scope.categories = result.data.category_map;
            var count = 1;
            for (i = 0; i < $scope.categories.length; i++) {
                if('meals' == Category.toLowerCase()) {
                    $scope.selectedCategory = -2;
                    $scope.getRestaurantList()
                    break;
                }

                else if ($scope.categories[i].category.toLowerCase() == Category.toLowerCase()) {
                    $scope.selectedCategory = $scope.categories[i].id;
                    $scope.getRestaurantList()
                    break;
                }
                if(count == $scope.categories.length){
                    $location.path('/not-available');
                    $rootScope.loading_custom = false;

                }
                count++;

            }

        });
    }

   // getFatafatCities()
    fetchCategories();


    $scope.searchText = {};
    $scope.searchText.name = null;
    $scope.selectedItem = {};
    $scope.isLoaded = false;
    $scope.cityId;
    $scope.restData;
    $scope.categoryFilter;
    $scope.filters;
    var sorting = [];
    var filters = [];
    var category_map_id = []
    $scope.disableValue = false;
    $scope.pageArray = [];



    $scope.a = true;
    var sortValue = "popularity";




    $scope.citySelect = function () {

        $window.location.href = "/fatafat/" + $scope.selectedItem.cityDetails.city_name.toLowerCase() + '/restaurants';
    }

    $scope.selectedItem.cityDetails = $routeParams.city_name;




}]).controller('categoriesCtrl', ['$scope', '$rootScope', '$window', '$timeout', '$location', 'API', '$routeParams','CITY',
    function ($scope, $rootScope, $window, $timeout, $location, API, $routeParams,CITY) {


        API.seDefaultData();
        $window.scrollTo(0, 0);
        $scope.selectedCity = $routeParams.city_name.charAt(0).toUpperCase() + $routeParams.city_name.substr(1).toLowerCase();

        var city;

        //CITY.fatafat().then(function(result) {
        //    var cities = result;
        //    var count = 1;
        //
        //    for (var i = 0; i < cities.length; i++) {
        //        if ($routeParams.city_name.toLowerCase() == cities[i].city_name.toLowerCase()) {
        //            if (!localStorage.getItem('long')) {
        //                    localStorage.setItem('lat', cities[i].latitude);
        //                    localStorage.setItem('long', cities[i].longitude);
        //            }
        //
        //            break;
        //        }
        //        if(count == cities.length)
        //        {
        //                $location.path('/404');
        //        }
        //        count++;
        //
        //    }
        //
        //
        //
        //})
        fetchCategories()

        function fetchCategories() {

            API.post(menu_base_url + "nearby_restaurants_v2", {

                access_token: guestToken,
                app_version: "364",
                device_type: "0",
                integrated: "1",
                client_id: "DC311uhPSZV6tKjT",
                latitude: localStorage.getItem('lat'),
                longitude: localStorage.getItem('long'),
                page_no: "0"


            }).then(function (result) {
                console.log(result)
                if (result.data.category_map.length) {
                    $scope.categories = result.data.category_map;
                }
                else {
                    $location.path('/not-available');

                }

                $scope.anythingAvailable = result.data.chat_available;
            });

        }



        $scope.checkLogin = function (param) {
            console.log(localStorage.getItem("accessToken"));

            if (localStorage.getItem("accessToken")) {
                $location.path("/fatafat/" + $routeParams.city_name.toLowerCase() + "/" + "anything")
            }

            else {
                $rootScope.openlogin();
                $rootScope.$broadcast('customButtonPressedEvent');
            }
        }


    }]).controller('anythingCtrl', ['$scope', '$mdDialog', '$rootScope', '$window', '$timeout', '$location', 'API', '$routeParams',
    function ($scope, $mdDialog, $rootScope, $window, $timeout, $location, API, $routeParams) {
        $window.scrollTo(0, 0);
        var token = localStorage.getItem("accessToken");
        var pickupLat = 0, pickupLong = 0;
        var dropLat;
        var dropLong;
        var time = "";

        if (localStorage.getItem("savedAddresses")) {
            $scope.savedAdresses = JSON.parse(localStorage.getItem("savedAddresses"));
            for (var i = 0; i < $scope.savedAdresses.length; i++) {
                if ($scope.savedAdresses[i].type && $scope.savedAdresses[i].type.toLowerCase() == 'home') {
                    var extra = $scope.savedAdresses[0];
                    $scope.savedAdresses[0] = $scope.savedAdresses[i];
                    $scope.savedAdresses[i] = extra;


                }
                if ($scope.savedAdresses[i].type && $scope.savedAdresses[i].type.toLowerCase() == 'work') {
                    var extra = $scope.savedAdresses[1];
                    $scope.savedAdresses[1] = $scope.savedAdresses[i];
                    $scope.savedAdresses[i] = extra;

                }
            }
        }
        $scope.anythingSelectedCity = $routeParams.city_name.charAt(0).toUpperCase() + $routeParams.city_name.substr(1).toLowerCase();

        $scope.deliveryIndex;
        $scope.pickupIndex;
        $scope.fullDeliveryAddress = "";
        $scope.fullPickupAddress = "Anywhere";
        $scope.selectedDeliveryLocality;
        $scope.selectedPickupLocality;
        $scope.pickupLabel = "";
        $scope.deliveryLabel = "";
        $scope.immediateDelivery = 1;
        $scope.error = "";
        $scope.order;
        $scope.LocalityDiv = false;


        var deliveryinput = document.getElementById('deliveryLocality');
        var options = {
            componentRestrictions: {
                country: 'ind'
            }
        };
        var deliveryAutocomplete = new google.maps.places.Autocomplete(deliveryinput, options);
        google.maps.event.addListener(deliveryAutocomplete, 'place_changed', function () {
            $timeout(function () {
                $scope.savedDeliveryLocality = document.getElementById('deliveryLocality').value;
                $scope.LocalityDiv = true;

            })

        });


        var pickupinput = document.getElementById('pickupLocality');
        var options = {
            componentRestrictions: {
                country: 'ind'
            }
        };
        var pickupAutocomplete = new google.maps.places.Autocomplete(pickupinput, options);

        google.maps.event.addListener(pickupAutocomplete, 'place_changed', function () {
            $timeout(function () {
                $scope.fullPickupAddress = document.getElementById('pickupLocality').value;
                $scope.selectedPickupLocality = "";

                console.log("erwe", $scope.selectedPickupLocality)
                geocoder = new google.maps.Geocoder();
                if (geocoder) {
                    geocoder.geocode({
                        'address': $scope.fullPickupAddress
                    }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            if (results[0]) {
                                //formatted address

                                //find country name
                                pickupLat = results[0].geometry.location.lat();
                                pickupLong = results[0].geometry.location.lng();
                                console.log("pickupLong", pickupLat, pickupLat);
                                $scope.error = "";


                            }

                        }
                        else {
                            $timeout(function () {
                                $scope.error = "Not a valid Pickup address";
                                showAlert();

                            })
                        }


                    });
                }
                $scope.pickupLabel = "";
                $scope.pickupIndex = -1;
                $('#pickupModal').modal('toggle');
                if ($scope.fullPickupAddress  && $scope.fullDeliveryAddress)
                    getEstimatedFare()
            })

        });

        $(function () {
            $('#datetimepicker12').datetimepicker({
                inline: true,
                minDate: moment().add({minutes: 30})
            });
            $('#datetimepicker12').on('dp.change', function (event) {
                time = event.date.format('YYYY/MM/DD HH:mm:ss');
                console.log(time);
                $(".day").on('click', function () {
                    $("a[data-action='togglePicker']").trigger('click');
                });


            });
        });
        $("#datetimepicker12").on("dp.show", function (e) {
            $(".day").on('click', function () {
                $("a[data-action='togglePicker']").trigger('click');
            });
        });


        $scope.changeTimeFromModal = function () {

            $scope.time = time ? time : moment().add({minutes: 30}).format('YYYY/MM/DD HH:mm:ss');
            $scope.time = moment($scope.time).format('D MMMM YYYY, h:mm a');
            $scope.immediateDelivery = 0;
            $scope.error = "";
            $("a[data-action='togglePicker']").trigger('click');
            $('#datetimepicker12').data('DateTimePicker').date(moment().add({minutes: 30}));
            $('#timeModal').modal('toggle');
        }


        $scope.changeDeliveryAddress = function (index, address) {
            $scope.deliveryIndex = index;
            $scope.fullDeliveryAddress = address.last_address;
            $scope.deliveryLabel = address.type;
            dropLat = address.delivery_latitude
            dropLong = address.delivery_longitude;
            fare()
            $('#deliveryModal').modal('toggle');
        }

        $scope.changePickupAddress = function (index, address) {
            $scope.pickupIndex = index;
            $scope.fullPickupAddress = address.last_address;
            $scope.pickupLabel = address.type;
            pickupLat = address.delivery_latitude;
            pickupLong = address.delivery_longitude;
            if ($scope.fullDeliveryAddress)
                fare()
            $('#pickupModal').modal('toggle');


        }
        $scope.anywhere = function () {
            $scope.fullPickupAddress = "Anywhere"
            pickupLat = 0
            pickupLong = 0
            $scope.pickupIndex = -1;
            $scope.error = "";
            $scope.pickupLabel = "";
            if ($scope.fullDeliveryAddress)
                fare()
            $('#pickupModal').modal('toggle');
        }

        $scope.scheduleTime = function () {

            if ($scope.immediateDelivery == 0) {
                $('#timeModal').modal('show');
            }
            else {
                $scope.time = "";
            }

        }

        $(document).on('hidden.bs.modal', '#timeModal', function () {
            if (!$scope.time) {
                $timeout(function () {
                    $scope.immediateDelivery = 1
                });
            }
        })


        $scope.saveDeliveryAddress = function () {
            var Address = $scope.savedDeliveryStreet + ", " + $scope.savedDeliveryLocality;
            var newAddress = $scope.savedLandmark ? $scope.savedDeliveryStreet + ", " + $scope.savedDeliveryLocality + ", " + $scope.savedLandmark : $scope.savedDeliveryStreet + ", " + $scope.savedDeliveryLocality;

            var newLat;
            var newLong;

            geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': Address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (results[0]) {
                            //formatted address
                            newLat = results[0].geometry.location.lat();
                            newLong = results[0].geometry.location.lng();
                            API.post(rides_baseUrl2 + "v2/add_home_and_work_address", {

                                "access_token": token,
                                "address": newAddress,
                                "google_place_id": "",
                                "type": $scope.savedDeliveryLabel,
                                "latitude": newLat,
                                "longitude": newLong,
                                "is_confirmed": 1,
                                "keep_duplicate": 0


                            }).then(function (result) {
                                if (result.data.flag == 143) {
                                    $scope.savedAdresses = result.data.addresses;
                                    for (i = 0; i < $scope.savedAdresses.length; i++) {


                                        $scope.savedAdresses[i].last_address =  $scope.savedAdresses[i].addr;
                                        $scope.savedAdresses[i].delivery_latitude = $scope.savedAdresses[i].lat;
                                        $scope.savedAdresses[i].delivery_longitude = $scope.savedAdresses[i].lng;


                                    }
                                    for (i = 0; i < $scope.savedAdresses.length; i++) {

                                    }
                                    console.log($scope.savedAdresses);

                                    localStorage.setItem("savedAddresses", JSON.stringify($scope.savedAdresses));
                                    $scope.LocalityDiv = false;
                                    $scope.addressError = "";
                                    document.getElementById("AddressForm").reset();
                                    document.getElementById('deliveryLocality').value = "";
                                }
                            });
                        }

                    }
                    else {


                    }

                });
            }

        }


        function fare() {
            API.get(fatafat_base_url + "get_all_details?device_type=0&app_version=357&to_latitude=" + dropLat + "&access_token=" + token + "&login_type=0&from_latitude=" + pickupLat + "&from_address=" + $scope.fullPickupAddress + "&to_longitude=" + dropLong + "&from_longitude=" + pickupLong).then(function (result) {
                if (result.data.flag == 143) {
                    $scope.fareDetails = result.data.delivery_charges;
                    $scope.error = "";

                }
                else {
                    $scope.error = result.data.responseMessage;
                    showAlert();

                }
            });

        }

        function getDropLatitudeLongitude(callback, address) {


            geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (results[0]) {
                            //formatted address

                            //find country name
                            dropLat = results[0].geometry.location.lat();
                            dropLong = results[0].geometry.location.lng();
                            $scope.error = "";

                            console.log("dropLatLong", dropLat, dropLong);
                            callback(fare, $scope.fullPickupAddress);


                        }

                    }
                    else {
                        $timeout(function () {
                            $scope.error = "Not a valid delivery address";
                            showAlert()

                        })

                    }

                });
            }


        }


        function getPickupLatitudeLongitude(callback, address) {

            geocoder = new google.maps.Geocoder();
            if (geocoder) {
                geocoder.geocode({
                    'address': address
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (results[0]) {
                            //formatted address

                            //find country name
                            pickupLat = results[0].geometry.location.lat();
                            pickupLong = results[0].geometry.location.lng();
                            console.log("pickupLong", pickupLat, pickupLat);
                            $scope.error = "";
                            callback();

                        }

                    }
                    else {
                        $timeout(function () {
                            $scope.error = "Not a valid Pickup address";
                            showAlert();

                        })
                    }


                });
            }


        }


        function getEstimatedFare() {

            getDropLatitudeLongitude(getPickupLatitudeLongitude, $scope.fullDeliveryAddress)
        }


        $scope.goBack = function () {
            $scope.LocalityDiv = false;
            document.getElementById("AddressForm").reset();
            document.getElementById('deliveryLocality').value = "";
        }


        function showAlert() {
            alert = $mdDialog.alert({

                textContent: $scope.error,
                ok: 'Close'
            });

            $mdDialog
                .show(alert)
                .finally(function () {
                    alert = undefined;
                });
        }

        $scope.placeOrder = function () {
            if ($scope.description && $scope.fullDeliveryAddress) {
                API.post(fatafat_base_url + "place_order", {
                    delivery_time: moment($scope.time).format('YYYY/MM/DD HH:mm:ss'),
                    device_type: '3',
                    is_immediate: $scope.immediateDelivery,
                    user_identifier: localStorage.getItem('userIdentifier'),
                    from_latitude: pickupLat,
                    details: $scope.description,
                    to_latitude: dropLat,
                    access_token: token,
                    login_type: '0',
                    from_address: $scope.fullPickupAddress,
                    to_address: $scope.fullDeliveryAddress,
                    to_longitude: dropLong,
                    from_longitude: pickupLong,
                }).then(function (result) {
                    if (result.data.flag == 143) {

                        $scope.orderDetails = result.data;
                        console.log($scope.orderDetails);
                        localStorage.setItem("orderDetails", JSON.stringify($scope.orderDetails));
                        $location.path("/order-history/" + 7 + "/" + $scope.orderDetails.order_id)
                    }
                    else {
                        $scope.error = result.data.message;
                        showAlert();
                    }
                });
            }
            else if ($scope.fullDeliveryAddress == "") {
                $scope.error = "Please confirm your delivery address.";
                showAlert();
            }

        }
    }]).controller('dishCtrl', ['$scope', '$rootScope', '$window', '$timeout', '$location', 'API', '$routeParams', '$document', function ($scope
    , $rootScope, $window, $timeout, $location, API, $routeParams, $document) {

        var lat , long ;
    $scope.mainSelectedCity = $routeParams.city_name.charAt(0).toUpperCase() + $routeParams.city_name.substr(1).replace(/-/g, ' ');
    $scope.category = $routeParams.category_name.charAt(0).toUpperCase() + $routeParams.category_name.substr(1).toLowerCase().replace(/-/g, ' ');
    $scope.dish = $routeParams.dish.charAt(0).toUpperCase() +  $routeParams.dish.substr(1).replace(/-/g, ' ');

    var dishes = ["biryani","milk-shake","north-indian","south-indian","parantha","aloo-parantha","dosa","masala-dosa","chinese","italian","fast-food","healthy-food","mughlai","rajasthani","seafood","sindhi","tibetan","mexican","tandoori","american","continental","oriental","arabic","gujarati","kashmiri","lebanese","oriental"]

    function getFatafatCities() {
        $rootScope.loading_custom = true;

        API.get(menu_base_url + 'website/get_cities').then(function (result) {
            $rootScope.loading_custom = true;
            if (result.data.flag == 143) {
                var fatafatCities = result.data.cities;
                var count = 1;
                for (i = 0; i < fatafatCities.length; i++) {
                    if ($routeParams.city_name.toLowerCase().replace(/-/g, ' ') == fatafatCities[i].city_name.toLowerCase()) {

                        lat = fatafatCities[i].latitude;
                        long = fatafatCities[i].longitude;
                        $scope.cityId = fatafatCities[i].city_id;
                        fetchCategories();
                        break;
                    }
                    if(count == fatafatCities.length){
                        $location.path('/404');
                        $rootScope.loading_custom = false;

                    }
                    count++;
                }
            }
            else {
                $scope.error = result.data.error
                $rootScope.loading_custom = false;
            }
        })

    }
    var pageNo = $location.search().page;
    $scope.getRestaurantList = function () {
        API.post(menu_base_url + "fetch_restaurant_via_search_v2", {
            search_text : $routeParams.dish,
            access_token: guestToken,
            device_type: "0",
            app_version: "365",
            client_id: "DC311uhPSZV6tKjT",
            login_type: 0,
            longitude: long,
            integrated: "1",
            latitude: lat,
            page_no:pageNo? pageNo - 1 : 0,
            merchant_category_id: $scope.selectedCategory

        }).then(function (result) {

            $window.scrollTo(0, 0);
            $scope.restData = result.data.vendors;
            $rootScope.loading_custom = false;
            $scope.totalResults = result.data.total_count;
            $scope.totalPages = Math.ceil($scope.totalResults / 20)
            $scope.pageArray = new Array($scope.totalPages);

            if (pageNo) {
                $scope.currentPage = parseInt(pageNo);
                $scope.startCount = 0;
                $scope.endCount = 5;

                if (pageNo > 5) {
                    if (pageNo % 5 == 0) {
                        $scope.startCount = pageNo - 5;
                        $scope.endCount = parseInt(pageNo);

                    }
                    else {
                        $scope.startCount = pageNo - pageNo % 5;
                        $scope.endCount = $scope.startCount + 5;

                    }
                }
                if(pageNo >  $scope.totalPages)
                {
                    $location.path('/404')
                }
            }
            else {
                $scope.startCount = 0;
                $scope.endCount = 5;
                $scope.currentPage = 1;
            }

            $rootScope.loading_custom = false;

        })
    }

    function fetchCategories() {
        API.post(menu_base_url + "nearby_restaurants_v2", {
            access_token: guestToken,
            from_website: true,
            login_type: 0,
            longitude: localStorage.getItem('long'),
            integrated: "1",
            latitude: localStorage.getItem('lat'),
            page_no: 0,
        }).then(function (result) {

            $scope.categories = result.data.category_map;
            var count = 1;
            for (i = 0; i < $scope.categories.length; i++) {
                if ($scope.categories[i].category.toLowerCase() == "restaurants" ) {
                    $scope.selectedCategory = $scope.categories[i].id;
                    $scope.getRestaurantList()
                    break;
                }
                if(count == $scope.categories.length){
                    $location.path('/404');
                    $rootScope.loading_custom = false;

                }
                count++;
            }

        });

    }
    var dishcount = 0;
    for(i=0;i<dishes.length;i++) {
        if(dishes[i] == $routeParams.dish) {
            getFatafatCities()
            break;
        }
        else if(dishcount == dishes.length - 1){
            $location.path('/404');
            $rootScope.loading_custom = false;
        }
        dishcount++;
    }


}])